import React, { useState } from "react";
import styled from "styled-components";
import ReviewFilter from "./ReviewFilter";
import ReviewsList from "./ReviewsList";

const ReviewsListVirtual = () => {
  const [appraisal, setAppraisal] = useState(null);

  return (
    <>
      <ReviewFilterOnPage
        onChange={(value) => {
          if (appraisal === value && appraisal !== null) {
            setAppraisal(null);
          } else {
            setAppraisal(value);
          }
        }}
      />
      <ReviewsList key={appraisal} appraisal={appraisal} />
    </>
  );
};

const ReviewFilterOnPage = styled(ReviewFilter)`
  padding: 24px 0 60px;

  @media (max-width: 980px) {
    padding-bottom: 40px;
  }
`;

export default ReviewsListVirtual;
